<!-- RESPONSIVE PART -->
@if (urlWeb()) {
  <a (click)="openLink(); (false)" [href]="hrefWeb()" [attr.aria-label]="urlLabel()">
    <ng-container
      [ngTemplateOutlet]="content"
      [ngTemplateOutletContext]="{ $implicit: isMobileWidth() ? img161() : img162() }"
    ></ng-container
  ></a>
} @else {
  <ng-container
    [ngTemplateOutlet]="content"
    [ngTemplateOutletContext]="{ $implicit: isMobileWidth() ? img161() : img162() }"
  ></ng-container>
}
<!-- CONTENT -->
<ng-template #content let-picture>
  <section
    class="my-1 position-relative ecm-megapush-wrapper"
    [style.background-image]="'url(' + picture + ')'"
    [attr.aria-label]="urlLabel()"
  >
    <!-- PROMO -->
    @if (tag()) {
      <div class="d-flex align-items-center" role="note" [attr.aria-labelledby]="'megapush-tag-label-' + cid()">
        <div [attr.id]="'megapush-tag-label-' + cid()" [innerHTML]="tagText() | sanitizeHtml"></div>
        @if (tagDate()) {
          <span class="small py-0" [ngClass]="textColor()" [innerHTML]="tagDate() | sanitizeHtml" aria-hidden="true">
          </span>
          <span class="sr-only" [attr.id]="'megapush-tag-date-label-' + cid()"> jusqu'au {{ tag()?.date }} </span>
        }
      </div>
    }
    <!-- Contenu texte sorti du @if tag pour toujours être affiché -->
    <div
      class="d-flex flex-column justify-content-center ecm-megapush-content"
      [ngClass]="isMobileWidth() ? 'pl-1 pr-0' : 'pl-2 pr-1'"
    >
      @if (titleContent()) {
        <p class="h3 mb-0" [innerHTML]="titleContent() | sanitizeHtml"></p>
      }
      @if (textContent()) {
        <p class="standard p-0" [innerHTML]="textContent() | sanitizeHtml"></p>
      }
    </div>

    @if (legal()?.label || energy()) {
      <div class="d-flex align-items-center mt-auto" [ngClass]="isMobileWidth() ? 'px-1' : 'px-2 mb-1'">
        @if (legal()?.label) {
          <a
            class="ob1-link-icon ob1-link-icon-small"
            [ngClass]="{ 'o-link-reverse': textColor() === 'text-white' }"
            href=""
            (click)="$event.stopPropagation(); $event.preventDefault(); openLegalModal()"
            aria-haspopup="dialog"
            [attr.aria-label]="legal()?.label + ' - Ouvre une fenêtre modale'"
          >
            <span class="icon icon-info-alt" aria-hidden="true"></span>
            <span class="ob1-link-icon-text">{{ legal()?.label }}</span>
          </a>
        }

        @if (energy()) {
          <img class="icon pl-1 min-h-[40px]" [src]="energy()" alt="" aria-hidden="true" />
        }
      </div>
    }
  </section>
</ng-template>
